
import Typography from '@mui/material/Typography';


export const TextDrugAbacavir = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

The EMA European Public Assessment Report (EPAR) for abacavir (Ziagen) states that screening for the HLA-B*5701 allele should be performed in any HIV-infected patient, 
and that the drug should not be used in patient's with the HLA-B*57:01 allele.
<br /><br />
Before initiating treatment with abacavir, screening for carriage of the HLA-B*5701 allele should be performed in any HIV-infected patient, irrespective of racial origin... 
Abacavir should not be used in patients known to carry the HLA-B*5701 allele.

<br /><br />


Sources: <br /><br />
https://www.pharmgkb.org/labelAnnotation/PA166104896 <br />
https://files.cpicpgx.org/data/guideline/publication/abacavir/2014/24561393-supplement.pdf
</Typography>

</div>

)
}